import {Injectable} from '@angular/core';
import {DcpBaseStoreModel, PaymentMethods} from '../model/dcp-config-service/basestores-country.model';
import {Observable, of} from 'rxjs';
import {DcpApiService} from '@dcp/configurator';
import {CountrySelectorService} from './country-selector.service';
import {PaymentTypeCode} from '../model/order/dcp-order.model';
import {UntilDestroy} from '@ngneat/until-destroy';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class BaseStoreService {
  /** Maps payment type code to allowed payment method */
  private allowedPaymentMethods: Map<PaymentTypeCode, PaymentMethods> = new Map([
    [PaymentTypeCode.ACCOUNT, PaymentMethods.INVOICE],
    [PaymentTypeCode.CARD, PaymentMethods.CREDITCARD],
  ]);

  constructor(private dcpApiService: DcpApiService, private countrySelectorService: CountrySelectorService) {}

  isCcAllowedForCountry(baseStore: DcpBaseStoreModel): boolean {
    return !!baseStore.deliveryModes.deliveryModes.find(
      (deliveryMode) => deliveryMode.code === PaymentMethods.CREDITCARD
    );
  }

  /**
   * Returns allowed payment method for given paymentTypeCode
   *
   * @param code
   */
  getAllowedPaymentMethodByType(code: PaymentTypeCode): PaymentMethods {
    return this.allowedPaymentMethods.get(code);
  }

  getCurrentBaseStore(): Observable<DcpBaseStoreModel> {
    const countryCode = this.countrySelectorService.getCurrentCountry()?.isocode;
    if (countryCode?.trim()) {
      return this.dcpApiService.callOcc<DcpBaseStoreModel>('basestoresByCountry', {countryCode});
    }
    return of();
  }
}
